<template>
  <div class="text-center">
    <div style="background: #192c51;"  v-if="typeOrigin == 'student'">
    <br>
        <p style="color:#fff;">El motivo de este mensaje es por que tenemos un lugar en nuestro equipo perfecto para ti: <br> <b style="color:#ed8f00;">{{data.title}}</b> <br>
        Da clic en el siguiente enlace para ver la información completa de la vacante :  <b style="color:#ed8f00;"><router-link :to="'/ver/empleo/' + data.job.url_public" style="color:#ed8f00;">Ver información</router-link></b> 
        </p>
    <br> 
    </div>
    <br>
    <b-form @submit="this.sendMessage">
        <b-form-textarea
            v-model="message"
            required
            placeholder="Escribe un mensaje..."
            rows="3"
            max-rows="6"
            ></b-form-textarea>
            <label class="d-block bh-cursor border-1 border-dashed p-4 border-gray-dark text-center font-gray-dark mt-3">
                <i class="fas fa-paperclip" v-show="!file"></i>
                <i class="fas fa-check-circle" v-show="file"></i>
                {{file ? file.name : 'Adjuntar archivo (opcional)'}}
                <input type="file" @change="handleFileUpload" hidden> 
            </label> 
           <b-button type="submit" class="b-blue shadow mt-2" :disabled="message == ''  || loading "><i class="fas fa-paper-plane"></i> Enviar Mensaje   <b-spinner v-if="loading" small label="Espere ..." class="p-2"></b-spinner></b-button>
    </b-form>
  </div>
</template>
<script>
export default {
    props:{
        data: Object
    },
    data() {
        return {
            message: '',
            loading: false,
            file:''
        }
    },
    computed: {
      typeOrigin: function () {
        return this.$store.getters.typeOrigin
      }
    },
    methods:{
        handleFileUpload(e) {
            this.file = e.target.files[0]
        },
        sendMessage(e){
            e.preventDefault()
            
              let form = new FormData() 

                form.append('conversation_id', this.data.id)
                form.append('message', this.message)
                form.append('file', this.file) 

            this.loading = true
            this.api.post('conversation/message', form).then(({data}) => {
                this.bus.$emit('message', data.message_data)
                this.message = ''
                this.file = ''
                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/messages/components/WriteMessage.vue